import {Competitor} from "./competitor";

export interface CompetitorSaveControlPointResult {
    competitor?: Competitor;
    status: CompetitorSaveControlPointResultStatus;
    key?: string;
}

export enum CompetitorSaveControlPointResultStatus {
    OK = "OK",
    DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
    NOT_STARTED = "NOT_STARTED",
    BEFORE_START_TIME = "BEFORE_START_TIME",
    AFTER_FINISH_TIME = "AFTER_FINISH_TIME",
    INVALID_CONTROL_POINT = "INVALID_CONTROL_POINT",
    MINIMAL_LAP_DURATION_ERROR = "MINIMAL_LAP_DURATION_ERROR",
    DUPLICATE_LAP_ENTRY = "DUPLICATE_LAP_ENTRY",
    FINISH_TIME_BEFORE_OTHER = "FINISH_TIME_BEFORE_OTHER",
    UNRECOGNIZED_COMPETITOR = "UNRECOGNIZED_COMPETITOR",
    DUPLICATE_LAP_DISTANCE_ENTRY = "DUPLICATE_LAP_DISTANCE_ENTRY"
}
